import React from "react";
import Hero from "../components/privacy-policy/Hero";
import PrivacyContent from "../components/privacy-policy/content";

const PrivacyPolicy = () => {
  return (
    <div className="">
      <Hero />
      <PrivacyContent />
    </div>
  );
};

export default PrivacyPolicy;
